export default __webpack_public_path__ + "static/media/guiaAndroid3.ca729ac5.png";